// extracted by mini-css-extract-plugin
module.exports = {"list":"LeftRegisterText-module--list--3KBfy"};